import script from "./WidgetApp.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetApp.vue?vue&type=script&setup=true&lang=js"

import "./WidgetApp.vue?vue&type=style&index=0&id=06c2a29b&lang=css"

const __exports__ = script;

export default __exports__